import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import UIButton from 'UIComponents/button/UIButton';
import { getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { WHATSAPP_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import styled from 'styled-components';
import DisabledAlertBase from './DisabledAlertBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BoldedSpan = styled.span.withConfig({
  displayName: "DisabledAlertUpgradeRequired__BoldedSpan",
  componentId: "sc-1gtd9zz-0"
})(["font-weight:600;"]);
const getAlertMessage = genericChannelId => {
  switch (genericChannelId) {
    case WHATSAPP_GENERIC_CHANNEL_ID:
      {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(BoldedSpan, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "composer-ui.capability-editor.disabled-editor.whatsapp.none.emphasizedText"
            })
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "composer-ui.capability-editor.disabled-editor.whatsapp.none.description"
          })]
        });
      }
    default:
      {
        return null;
      }
  }
};
const DisabledAlertUpgradeRequired = ({
  message
}) => {
  const genericChannelId = getGenericChannelId(message);
  const upgradeLink = `${getFullUrl('app')}/pricing/${PortalIdParser.get()}`;
  return /*#__PURE__*/_jsx(DisabledAlertBase, {
    message: getAlertMessage(genericChannelId),
    type: 'danger',
    button: /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary",
      size: "extra-small",
      external: true,
      href: upgradeLink,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.capability-editor.disabled-editor.upgrade"
      })
    })
  });
};
DisabledAlertUpgradeRequired.displayName = 'DisabledAlertUpgradeRequired';
export default DisabledAlertUpgradeRequired;